import {Fragment, useEffect, useState} from 'react';
import React from "react";
import ListEdit from "../UI/ListEdit";
import Box from "../UI/Box";
import {useUserThematics} from "../../hooks/useUserThematics";
import {addUserThematic, deleteUserThematics, findAssignableThematics} from "../../api/userThematicApiClient";
import Button from "../UI/Button";
import UserThematicModal from "./UserThematicModal";
import {toast} from "react-toastify";

const UserThematicList = (props) => {
    const [thematics, setThematics] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const {userThematics, loading, reload} = useUserThematics(props.userId);

    useEffect(() => {
        findAssignableThematics()
            .then((data) => setThematics(data))
            .catch((error) => console.log(error));
    }, []);

    const assignedThematics = userThematics.map((userThematic) => userThematic.thematic);
    const assignedThematicIds = assignedThematics.map((thematic) => thematic.thematicId);
    const notAssignedThematics = thematics.filter((thematic) => !assignedThematicIds.includes(thematic.thematicId));

    const applyThematicIds = (thematicIds) => {
        setSaving(true);

        return deleteUserThematics(props.userId)
            .then(() => Promise.allSettled(
                thematicIds.map((thematicId) => addUserThematic(props.userId, thematicId))
            ))
            .then((results) => {
                const hasFailure = results.some((result) => result.status === 'rejected');

                if (hasFailure) {
                    toast.error('Failed to save some of the thematics, the list may be out of sync. Reloading the actual state.');
                }
                else {
                    toast.success('Success!');
                }
            })
            .catch((error) => {
                toast.error(error.message ?? 'Failed to save user thematics');
            })
            .finally(() => {
                setSaving(false);
                reload().catch((error) => console.log(error));
            });
    }

    const handleAddThematicButtonClick = () => {
        setShowModal(true);
    }

    const handleAddSubmit = (thematicId) => {
        setShowModal(false);
        applyThematicIds([...assignedThematicIds, thematicId]);
    }

    const handleDeleteIconClick = (thematicId) => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('Are you sure?')) {
            applyThematicIds(assignedThematicIds.filter((id) => id !== thematicId));
        }
    }

    const listHeaders = [
        'Thematic',
        'Actions'
    ];

    const columns = {
        functionParams : ['thematicId'],
        dataKeys       : [
            'name'
        ],
    }

    return <Fragment>
        <Button
            title="Add Thematic"
            handleClick={handleAddThematicButtonClick}
            disabled={saving || loading || notAssignedThematics.length === 0}
        />
        <Box>
            <ListEdit
                headers={listHeaders}
                items={assignedThematics}
                columns={columns}
                handleDeleteIconClick={handleDeleteIconClick}
            />
        </Box>
        {
            showModal && <UserThematicModal
                thematics={notAssignedThematics}
                handleCancel={function () {
                    setShowModal(false);
                }}
                handleSubmit={handleAddSubmit}
            />
        }
    </Fragment>;
}

export default UserThematicList;
